// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-1d313b60]{display:none}.svg-image[data-v-1d313b60]{align-items:center;display:inline-flex}.svg-image svg[data-v-1d313b60]{fill:currentColor}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
